// @ts-check

import { MapView, Mappedin, MappedinNode, getVenue } from "@mappedin/mappedin-js";
import { useEffect, useState } from "react";
import { useMapClick } from "./Mappedin/useMapClick";
import React from "react";


/**
 * @typedef {React.MutableRefObject<null | MappedinNode>} MapNodeRef
 * 
 */


/**
 * @param {MapView | undefined} mapView
 * @param {any} props
 * 
 * @returns {[ MapNodeRef]}
 */
export default function useHandleMapClick(mapView, props) {

  let refCurrentMapNode = React.useRef(null);

  let handler = getMapClickHandler(props, mapView, refCurrentMapNode);

  // useMapClick(mapView, (p) => { console.log('p ===> ', p); });
  useMapClick(mapView, handler);


  return [
    refCurrentMapNode
  ];
}



/////////////////////////////////////////////////////


/**
 * @param {MapView | undefined} mapView
 * @param {any} props
 * @param {MapNodeRef} refCurrentMapNode
 * 
 * @returns {(event: import("@mappedin/mappedin-js").TMapClickEvent) => void}
 */
export let getMapClickHandler = (props, mapView, refCurrentMapNode) => {


  let actions = props.actions;


  /**
   * @param {import("@mappedin/mappedin-js").TMapClickEvent} payload
   */
  let mapClickHandler = (payload) => {

    // console.log("map click 3", payload);
    // console.log(`position => lat ${payload.position.latitude}, lng ${payload.position.longitude}`);


    if (!mapView) {
      return;
    }
    
    // console.log('ZZZZZZZZZUPPPPPPPPPPAAAAAAAAAAA ===> ', mapView.Camera.rotation, mapView.Camera.tilt, mapView.Camera.zoom);

    let polygons = payload.polygons;
    
    // No polygons means we clicked on the map non-interactive area.
    if (polygons.length < 1) {
      
      // Hide location tooltip via message to the store.
      actions.hideLocationTooltip();
      
      // Reset the current map node.
      refCurrentMapNode.current = null;
      
      return;
    }


    let selectedPolygon = polygons[0];
    if (!selectedPolygon) {
      return;
    }



    /////////////////////////////////////////// 
    // In a real map, the externalId will be 
    // equal to the Location name.
    //
    let externalId = selectedPolygon.externalId || 'NONE';
    let tpoLocationName = dev_getTpoLocationNameByMappExternalId(externalId);
    //console.log('Map externalId ===> ', externalId, 'tpoLocationName ===> ', tpoLocationName);

    // Start async fetch
    actions.fetchLocationDetails({ externalId: tpoLocationName });


    let entrance = selectedPolygon.entrances[0];
    if (!entrance) {
      return;
    }
    
    // Update the current map node.
    refCurrentMapNode.current = entrance;

  };




  return mapClickHandler;

};





/**
 * @param {string} mapExternalId
 */
function dev_getTpoLocationNameByMappExternalId(mapExternalId) {
  
  console.log('EXTERNAL_ID ZZZ ===> ', mapExternalId);
  
  
  return mapExternalId;
  

  // // if (mapExternalId === 'G18') {
  // //   return "Cut & Kit E347";
  // // }

  // // if (mapExternalId === 'F18') {
  // //   return "Clean Room CC884";
  // // }


  // if (mapExternalId === 'POLY-J0G4A03Y') {
  //   return "Cut & Kit E347";
  // }

  // if (mapExternalId === 'POLY-5A88S2R5') {
  //   return "Clean Room CC884";
  // }


  // return "Cut & Kit E347";
  
  
}




